// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uv-0";
export var checkoutRateBadgeLink = "_uv-1";